import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics, logEvent } from '../../services/firebase';

/**
 * This component tracks page views for a Single-Page Application (SPA)
 * and sends them to Firebase Analytics. It should be placed inside
 * the React Router's <Router> component.
 */
const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Log a page_view event every time the location changes.
    // Firebase automatically collects some parameters like page_location (URL),
    // but we can be more explicit by providing page_path and page_title.
    logEvent(analytics, 'page_view', {
      page_path: location.pathname + location.search,
    });
  }, [location]);

  return null; // This component does not render anything.
};

export default AnalyticsTracker;
